import {
  queryOptions,
  infiniteQueryOptions,
  keepPreviousData
} from '@tanstack/react-query';
import { operatorsApi } from './operators.api';
import type { OperatorsListParams } from '../types';

export const operatorKeys = {
  all: ['operators'] as const,
  lists: () => [...operatorKeys.all, 'list'] as const,
  list: (filters: OperatorsListParams) =>
    [...operatorKeys.lists(), filters] as const,
  infiniteLists: () => [...operatorKeys.all, 'infinite'] as const,
  infiniteList: (filters: OperatorsListParams) =>
    [...operatorKeys.infiniteLists(), filters] as const,
  details: () => [...operatorKeys.all, 'detail'] as const,
  detail: (id: number) => [...operatorKeys.details(), id] as const
};

export const operatorQueries = {
  list: (filters: OperatorsListParams = {}) =>
    queryOptions({
      queryKey: operatorKeys.list(filters),
      queryFn: () => operatorsApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  /**
   * Page-cursor infinite variant for scroll-to-load surfaces (e.g. the
   * operator-selection card grid). `filters` must not include `page` — the
   * cursor owns it.
   */
  infiniteList: (filters: OperatorsListParams = {}) =>
    infiniteQueryOptions({
      queryKey: operatorKeys.infiniteList(filters),
      queryFn: ({ pageParam }) =>
        operatorsApi.getAll({ ...filters, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) =>
        lastPage.pagination?.hasNext ? lastPage.pagination.page + 1 : undefined,
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: operatorKeys.detail(id),
      queryFn: () => operatorsApi.getById(id),
      enabled: id > 0
    })
};
